const getters = {
    enrollStatus: state => state.enrollStatus,
    enrollErrors: state => state.enrollErrors,
    enrollments: state => state.enrollments,
}

export default getters